<button (click)="openAddContactForm()" *ngIf="!isEdit" class="invited-chip" mat-raised-button>
	Add Contact
</button>

<mat-icon
	(click)="openAddContactForm()"
	*ngIf="isEdit"
	style="margin-right: 0.5rem; cursor: pointer"
	>edit</mat-icon
>
